import { Alert, Anchor, Box } from '@zillow/constellation-10';
import { stringHelper } from '@zg-rentals/rental-manager-env';

type Props = {
  errors: Array<unknown>;
};

const DiscriminatoryContentErrorAlert = ({ errors }: Props) => {
  const captionWord = stringHelper.pluralizeWord(errors.length, 'caption', 'captions');

  return (
    <Box css={{ marginBlock: '400' }}>
      <Alert tone="warning">
        {`${errors.length} of your ${captionWord} does not comply with Zillow’s `}
        <Anchor href="https://www.zillow.com/z/info/good-neighbor-policy/" target="_blank" rel="noopener noreferrer">
          Good Neighbor Policy
        </Anchor>{' '}
        or{' '}
        <Anchor
          href="https://www.zillow.com/rental-manager/resources/zillow-respectful-renting-pledge/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Respectful Renting Pledge
        </Anchor>
        {'. '}
        Revise your {captionWord} in order to save and publish it to your listing
      </Alert>
    </Box>
  );
};

export default DiscriminatoryContentErrorAlert;
